import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=cf7603a8"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports